
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class ConvertToWIPItemsGrid extends Serenity.EntityGrid<ConvertToWIPItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.ConvertToWIPItems'; }
        protected getDialogType() { return ConvertToWIPItemsDialog; }
        protected getIdProperty() { return ConvertToWIPItemsRow.idProperty; }
        protected getInsertPermission() { return ConvertToWIPItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ConvertToWIPItemsRow.localTextPrefix; }
        protected getService() { return ConvertToWIPItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}